module.exports = __webpack_public_path__ + "static/img/longin_style1.8af061d8.png";